/**
 * Quota Types
 *
 * Sales quotas/targets defined at org, team, or rep scope over a period.
 * Attainment compares actual closed-won amount against the period target.
 */
import { z } from 'zod';
// =============================================================================
// Primitives
// =============================================================================
/** Scope a quota applies to. Derived from QUOTA_SCOPES so union and array cannot drift. */
export const QUOTA_SCOPES = ['org', 'team', 'rep'];
/** Cadence a quota target covers. */
export const QUOTA_PERIOD_TYPES = ['daily', 'monthly', 'quarterly', 'yearly'];
export const OrgQuotaSchema = z.object({
    id: z.string().uuid(),
    orgId: z.string().min(1),
    scope: z.enum(QUOTA_SCOPES),
    userId: z.string().nullable(),
    teamId: z.string().nullable(),
    periodType: z.enum(QUOTA_PERIOD_TYPES),
    periodStart: z.string(),
    targetAmount: z.number(),
    currency: z.string(),
    createdBy: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
